module.exports = __webpack_public_path__ + "assets/1412f9b14bfc1444c45e7d445deae3fb.mp3";